import { defineStore } from 'pinia'

export const useDashboardStore = defineStore('dashboard', {
  state: () => ({
    filters: {
      fase: null,
      tipoServicio: null,
      tipoCliente: null,
      tecnico: null,
      alertColor: [],
      on_site: null,
      despacho: null,
      mostrarCerradas: true,
    },
    loading: false,
    sortBy: null,
    sortDesc: false,
    tab: null,
  }),

  getters: {
    queryParams: (state) => {
      const { filters: f } = state
      return {
        servicio: f.tipoServicio || 0,
        tecnico: f.tecnico || 0,
        tipo_cliente: f.tipoCliente,
        alert_color: f.alertColor,
        on_site: f.on_site || false,
        despacho: f.despacho || null,
      }
    },
  },

  actions: {
    setFilter(key, value) {
      this.filters[key] = value
    },
    setFilters(filters) {
      Object.keys(filters).forEach((key) => {
        this.filters[key] = filters[key]
      })
    },
  },
})
